import { render, staticRenderFns } from "./tame-your-to-do-list-a45.vue?vue&type=template&id=735d5dd1&"
import script from "./tame-your-to-do-list-a45.vue?vue&type=script&lang=js&"
export * from "./tame-your-to-do-list-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports